module.exports = __webpack_public_path__ + "img/sm-trolley.a30bd5d9.webp";